import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

export const getAdditionsBasedOnBuilding = (building_id, params) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.additionEndPoints.getAdditionsBasedOnBuilding}/${building_id}/additions`,
        { params }
    );
export const getAdditions = params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAdditions}`, { params });
export const uploadExcelData = params => fcaFastApi.post(`${serviceEndpoints.additionEndPoints.uploadExcelData}`, params);
export const addAddition = (building_id, params) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).post(
        `${serviceEndpoints.additionEndPoints.addAddition}/${building_id}/additions`,
        params
    );
export const getAdditionById = (building_id, floor_id) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.additionEndPoints.getAdditionById}/${building_id}/additions/${floor_id}`
    );
export const updateAddition = (building_id, floor_id, params, type) =>
    type === "lineEdit"
        ? // line_update stays on Rails (not part of the geo writes slice).
          fcaGateWay.patch(`${serviceEndpoints.additionEndPoints.additionLineEdit}/${floor_id}/line_update`, params)
        : (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).patch(
              `${serviceEndpoints.additionEndPoints.updateAddition}/${building_id}/additions/${floor_id}`,
              params
          );
export const deleteAddition = (building_id, floor_id) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).delete(
        `${serviceEndpoints.additionEndPoints.deleteAddition}/${building_id}/additions/${floor_id}`
    );
export const getListForCommonFilter = params =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getListForCommonFilter}/${params.building_id}/additions/get_list`, {
        params
    });

export const getListForCommonFilterAdiiton = params =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllAdditionLogs}/get_list`, {
        params
    });
export const exportAdditionsByBuilding = (buildingId, params) =>
    fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.exportBuildings}/${buildingId}/additions/export_xl`, {
        method: "GET",
        responseType: "blob",
        params
    });
export const exportAdditions = params =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllAdditionLogs}/export_xl`, {
        method: "GET",
        responseType: "blob",
        params
    });

export const getAllAdditionLogs = (id, params) => {
    return fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllAdditionLogs}/${id}/logs`, { params });
};
export const restoreAdditionLog = id =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).patch(`${serviceEndpoints.additionEndPoints.restoreAdditionLog}/${id}/restore`);
export const deleteAdditionLog = id => fcaGateWay.delete(`${serviceEndpoints.additionEndPoints.deleteAdditionLog}/${id}`);
export const getAllClientUsers = params =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllClientUsers}/client_users_dropdown`, { params });

export const getAllConsultancyUsers = params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllConsultancyUsers}`, { params });

export const getAllConsultanciesDropdown = () =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllConsultanciesDropdown}/consultancies_dropdown`);

export const getAllClientss = params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllClients}`, { params });
// export const getAllBuildingss = params =>
//     fcaGateWay.get(serviceEndpoints.additionEndPoints.getAllBuildings, { params });
export const getAllBuildingsDropdown = params =>
    fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params });

export const getBAIPreview = (params, fileType) =>
    fcaReportGateway.post(
        `${serviceEndpoints.additionEndPoints.getBAIPreview}`,
        { ...params, format: fileType },
        {
            method: "POST",
            responseType: "blob"
        }
    );

export const getAdditionCommonDataByIds = params => fcaFastApi.post(serviceEndpoints.additionEndPoints.getAdditionCommonDataByIds, params);

export const updateMultiAdditions = params => fcaFastApi.patch(serviceEndpoints.additionEndPoints.updateMultiAdditions, params);

export const getAllAdditionIds = (building_id, params, isBuildingInfo) =>
    !isBuildingInfo
        ? fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAdditions}/group_edit_ids`, {
              params
          })
        : fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllAdditionIds}/${building_id}/additions/group_edit_ids`, {
              params
          });
